module.exports = __webpack_public_path__ + "img/threeFoot.ac2a4b8c.jpg";